<template>
  <v-dialog v-model="loading" hide-overlay persistent width="700">
    <v-card color="primary" dark>
      <v-card-text>
        Loading
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ["value"],
    data() {
      return {
        loading: this.value,
      };
    },
    watch: {
      value() {
        this.loading = this.value;
      },
      loading() {
        this.$emit("input", this.loading);
      },
    },
  };
</script>
